import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-three-lesson-three-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitThreeLessonThreeGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 3, Lesson 3 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 3: Informational Interviews";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
